/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ScanToPayPaymentMethodsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ScanToPayPaymentMethodsQuery = {
  readonly __typename?: 'Query';
  readonly paymentMethodCards: ReadonlyArray<
    | { readonly __typename?: 'PaymentMethodBillingAccount' }
    | {
        readonly __typename: 'PaymentMethodCard';
        readonly id: string;
        readonly description: string | null;
        readonly nickname: string | null;
        readonly isDefault: boolean;
        readonly cardType: Types.CardType;
        readonly expirationState: Types.CardExpirationState;
      }
  >;
};

export const ScanToPayPaymentMethodsDocument = gql`
  query ScanToPayPaymentMethods {
    paymentMethodCards {
      ... on PaymentMethodCard {
        __typename
        id
        description
        nickname
        isDefault
        cardType
        expirationState
      }
    }
  }
`;

export function useScanToPayPaymentMethodsQuery(
  options?: Omit<Urql.UseQueryArgs<ScanToPayPaymentMethodsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ScanToPayPaymentMethodsQuery, ScanToPayPaymentMethodsQueryVariables>({
    query: ScanToPayPaymentMethodsDocument,
    ...options,
  });
}
